var map = {
	"./chapter-30.png": "ed52",
	"./chapter-40.png": "e50b",
	"./chapter-50.png": "8b4d",
	"./chapter-60.png": "4d26",
	"./chapter-err-ai.png": "a6941"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1459";